const IP_OCTET_REGEX = /(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/;
const BASE_IP_ADDR_REGEX = new RegExp(
  `${IP_OCTET_REGEX.source}\\.${IP_OCTET_REGEX.source}\\.${IP_OCTET_REGEX.source}\\.${IP_OCTET_REGEX.source}`,
);

const IP_ADDR_REGEX = new RegExp(`^${BASE_IP_ADDR_REGEX.source}$`);

const IP_RANGE_REGEX = new RegExp(
  `^(${BASE_IP_ADDR_REGEX.source})-(${BASE_IP_ADDR_REGEX.source})$`,
);

const SHORTCUT_REGEX = new RegExp(
  `(${IP_OCTET_REGEX.source}\\.)?(${IP_OCTET_REGEX.source}\\.)?(${IP_OCTET_REGEX.source})`,
);
const SHORTCUT_IP_RANGE_REGEX = new RegExp(
  `^(${BASE_IP_ADDR_REGEX.source})-(${SHORTCUT_REGEX.source})$`,
);

const CIDR_REGEX = new RegExp(
  `^${BASE_IP_ADDR_REGEX.source}/(3[0-2]|[12]?[0-9])$`,
);

const NETMASK_REGEX = new RegExp(
  `^${BASE_IP_ADDR_REGEX.source}/${BASE_IP_ADDR_REGEX.source}`,
);

// from: https://stackoverflow.com/questions/8105629/ip-addresses-stored-as-int-results-in-overflow
function ip2num(ip) {
  const d = ip.split('.');
  return ((+d[0] * 256 + +d[1]) * 256 + +d[2]) * 256 + +d[3];
}

export function verifyIpRange(beginIP, endIp) {
  if (!beginIP || !endIp) {
    return false;
  }
  return ip2num(beginIP) <= ip2num(endIp);
}

export function verifyIpAddressNotation(notation) {
  if (notation) {
    const cleanedNotation = notation.replace(/\s+/g, '');

    if (
      cleanedNotation.match(IP_ADDR_REGEX) ||
      cleanedNotation.match(CIDR_REGEX) ||
      cleanedNotation.match(NETMASK_REGEX)
    ) {
      return true;
    }

    const rangeResult = cleanedNotation.match(IP_RANGE_REGEX);
    if (rangeResult) {
      return verifyIpRange(rangeResult[1], rangeResult[6]);
    }

    const shortcutResult = cleanedNotation.match(SHORTCUT_IP_RANGE_REGEX);
    if (shortcutResult) {
      const beginIp = shortcutResult[1];
      const end = shortcutResult[6];
      const numOctets = Math.max(end.split('.').length, 1);
      const endIp = `${shortcutResult
        .slice(2, 6 - numOctets)
        .join('.')}.${end}`;

      return verifyIpRange(beginIp, endIp);
    }
  }
  return false;
}
